/**
 * Static WordPress template, chart type and report type values. 
 * These values rarely change and if they do it is a structural change
 * No need for environment variables. 
 */
export default class TemplateDefinitions {

    static TEMPLATE_REPORT_PAGE = "report_template.php";
    static TEMPLATE_CHART_PAGE = "chart_template.php";
    static TEMPLATE_ARTICLE_PAGE = "articles_template.php";
    static TEMPLATE_MY_ACCOUNT_PAGE = "my_account_template.php";
    static TEMPLATE_CHANGE_PASSWORD_PAGE = "change_password_template.php";
    static TEMPLATE_EVENT_PAGE = "events_template.php";
    static TEMPLATE_VIEW_FPU_LIST_PAGE = "my_fpu_list_template.php";
    static TEMPLATE_NOTIFICATIONS_PAGE = "notifications_template.php";
    static TEMPLATE_CONTACT_PAGE = "contact_form_template.php";

    static REPORT_TYPE_DAILY_COMPONENTS = "daily-components";
    static REPORT_TYPE_HISTORICAL_QUALITY = "historical-quality";
    static REPORT_TYPE_CURRENT_QUALITY = "current-quality";
    static REPORT_TYPE_COOP_PRICE_PROJECTION = "milk-pricing-coop";
    static REPORT_TYPE_MONTANA_PRICE_PROJECTION = "milk-pricing-montana";
    
    
}